import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ChartOfAccount, ChartOfAccountCreate, ChartOfAccountFilter } from '../data/chartOfAccount';

export function createChartOfAccountService(client: AxiosInstance) {
  return createCrudService<ChartOfAccount, ChartOfAccountCreate, ChartOfAccountFilter>(
    client,
    '/accounting/ChartOfAccount',
    'id',
  );
}

export type ChartOfAccountService = CrudService<ChartOfAccount, ChartOfAccountCreate, ChartOfAccountFilter>;
